import { toast } from "sonner";

// Identical error messages collapse into one toast instead of stacking (same id = update in place).
const originalError = toast.error;
toast.error = (message, opts = {}) => {
  const id = opts.id ?? (typeof message === "string" ? `err:${message}` : undefined);
  return originalError(message, id ? { ...opts, id } : opts);
};
